// 请求接口地址 如果没有配置自动获取当前网址路径
var VUE_APP_API_URL = process.env.VUE_APP_BASE_API || "".concat(location.origin);
var normalizedApiURL = VUE_APP_API_URL.replace(/\/+$/, '');
var adminApiPrefix = /\/admin$/.test(normalizedApiURL) ? '/api/' : '/admin/api/';
// const VUE_APP_API_URL2 = process.env.VUE_APP_BASE_API2 || `${location.origin}`;
var VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || (location.protocol === 'https' ? 'wss' : 'ws') + ':' + location.hostname;

// 所属平台：1=商城平台，2=淘客平台
// 本项目是淘客后台，.env 里配 VUE_APP_PLAT_TYPE=2；登录时带给后端，
// 后端按 account + type + plat_type 命中账号，商城商户账号进不来，淘客账号也进不了商城后台。
var PLAT_TYPE = Number(process.env.VUE_APP_PLAT_TYPE) || 1;

// const apiBaseURL = /\/api\/?$/.test(VUE_APP_API_URL) ? VUE_APP_API_URL.replace(/\/?$/, '/') : VUE_APP_API_URL + '/api/';

var SettingMer = {
  // 服务器地址
  httpUrl: VUE_APP_API_URL,
  // 接口请求地址
  apiBaseURL: normalizedApiURL + adminApiPrefix,
  // apiBaseURL2: VUE_APP_API_URL2 + '/',
  apiBaseURL2: VUE_APP_API_URL + '/flowable/',
  // apiBaseURL,
  // socket连接
  wsSocketUrl: VUE_APP_WS_URL,
  // 是否为平台端
  isPlatform: isPlatform,
  // 所属平台：1=商城平台，2=淘客平台
  platType: PLAT_TYPE
};
// 判断是否为平台端路由
var isPlatform = isPlatformPath();
function isPlatformPath() {
  var path = window.location.pathname;
  if (path == '/') return true;
  return path.split('/')[1] ? path.split('/')[1].toLowerCase() !== 'circle' : false;
}
// 导出 isPlatform 函数
export { isPlatform, PLAT_TYPE };
export default SettingMer;